<template>
<div class="leaderActivityDialog">
    <el-dialog @close='cancel' title="团长活动" :visible.sync="dialogVisible" width="1000px">
        <div class="search_box">
            <el-button type="success" @click="handleExport">导出数据</el-button>
            <div></div>
        </div>
        <div class="add_goods_tabs_box">
            <el-table :data="tableData" style="width: 100%" ref="multipleTable">
                <el-table-column label="团长名称" min-width="300px">
                    <template slot-scope="scope">
                        <div class="goods_item_box">
                            <img class="headerImg" v-lazy="scope.row.rolehostlogourl" alt>
                            <div>{{scope.row.rolehostname}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="viewcount" label="浏览量（PV）" class-name="center" min-width="120"></el-table-column>
                <el-table-column prop="viewcustomercount" label="访问人数（UV）" class-name="center" min-width="120"></el-table-column>
                <el-table-column prop="ordersucccount" label="订单数" class-name="center" min-width="120"></el-table-column>
                <el-table-column prop="totalincome" label="订单金额（￥）" class-name="center" min-width="120">
                    <template slot-scope="scope">{{scope.row.totalincome?'￥'+scope.row.totalincome:'-'}}</template>
                </el-table-column>
                <el-table-column prop="brokeragetotal" label="销售佣金（￥）" class-name="center" min-width="120">
                    <template slot-scope="scope">{{scope.row.brokeragetotal?'￥'+scope.row.brokeragetotal:'-'}}</template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page" style="margin-top: 15px; text-align: center">
            <el-pagination
                background
                @current-change="handleSizeChange"
                :current-page.sync="page.page"
                :page-size="page.pageSize"
                :pager-count="11"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {getEventHeaderListByEvent, exportEventHeaderListByEvent} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'

export default {
    name: 'leaderActivityDialog',
    data() {
        return {
            param: {
                eventid: ''
            },
            page: {
                page: 1,
                pageSize: 5,
                pageCount: 0
            },
            total: 0,
            dialogVisible: false,
            tableData: []
        }
    },
    mounted() {
    },
    methods: {
        openDialog(eventid) {
            this.param.eventid = eventid
            this.dialogVisible = true
            this._getList()
        },
        cancel() {
            this.page = {
                page: 1,
                pageSize: 5,
                pageCount: 0
            }
            this.dialogVisible = false
        },
        handleSizeChange() {
            this._getList()
        },
        handleExport() {
            this.setLoading(true)
            exportEventHeaderListByEvent({
                data: Object.assign({}, this.param),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '活动团长' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getEventHeaderListByEvent({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.headerlist
                    this.total = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading', 'setBrandBusiness'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.leaderActivityDialog {
    .el-table {
        min-height: 340px;
    }
    .goods_item_box {
        display: flex;
        align-items: center;
        height: 42px;
        box-sizing: border-box;
        .headerImg {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .el-table__empty-block {
        height: 340px;
        max-height: 340px;
    }
    .el-table__empty-text {
        position: relative;
        top: 80px;
    }
}
</style>
